
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ServiceHero from './components/ServiceHero';
import RegionCards from './components/RegionCards';
import CoverageMap from './components/CoverageMap';
import CityDirectory from './components/CityDirectory';
import WhyChooseUs from './components/WhyChooseUs';
import RequestForm from './components/RequestForm';

export default function ServiceAreasPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <ServiceHero />

      <RegionCards />

      <CoverageMap />

      <CityDirectory />

      <WhyChooseUs />

      <RequestForm />

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-brand-navy mb-4">
            Ready to Start Saving?
          </h2>
          <p className="text-gray-600 mb-8 max-w-xl mx-auto">
            Get a free home energy assessment and discover how much you could save with our HVAC, solar, and insulation solutions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+18005551234"
              className="inline-flex items-center justify-center gap-2 bg-brand-red text-white px-8 py-4 rounded-full font-semibold hover:bg-brand-red-dark transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-brand-red/20"
            >
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
              Call (800) 555-1234
            </a>
            <Link
              to="/savings-calculator"
              className="inline-flex items-center justify-center gap-2 border-2 border-brand-navy text-brand-navy px-8 py-4 rounded-full font-semibold hover:bg-brand-navy hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calculator-line w-5 h-5 flex items-center justify-center"></i>
              Calculate Your Savings
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
